module.exports = __webpack_public_path__ + "static/track-bg-c7b02d8da495afd79fa212e8c5596fc2.png";